import {
  MODEL_ID,
  PROVIDER,
  ACTION,
  MODE,
  SPLIT_MODE,
  SPLIT_LAYOUT,
  CONNECTOR_TYPE,
  SPLIT_OUTPUT_FORMAT,
} from 'Pods/ThreeDStudio/Store/constants'

// Meshy Auto Split. The backend resolves input_3d to the Meshy task that generated
// the asset (Generator::Providers::Meshy::SplitSourceTask), so only Meshy models
// qualify; see getAutoSplitEligibility.
export default {
  "model_id": MODEL_ID.MESHY_MESH_SEGMENTATION_PRO,
  "provider": PROVIDER.MESHY,
  "action": ACTION.MESH_SEGMENTATION,
  "mode": MODE.NORMAL,
  "input_schema": {
    "type": "object",
    "properties": {
      "input_3d": {
        "type": "string",
        "allowedTypes": ['glb', 'gltf', 'fbx', 'obj', 'stl'],
        "maxFileSize": 200 * 1024 * 1024,
      },
      "split_mode": {
        "type": "string",
        "enum": Object.values(SPLIT_MODE),
        "default": SPLIT_MODE.AUTO,
      },
      "prompt": {
        "type": "string",
        "maxLength": 600,
      },
      "layout": {
        "type": "string",
        "enum": Object.values(SPLIT_LAYOUT),
        "default": SPLIT_LAYOUT.ASSEMBLED,
      },
      "connectors": {
        "type": "boolean",
        "default": false,
      },
      "connector_type": {
        "type": "string",
        "enum": Object.values(CONNECTOR_TYPE),
        "default": CONNECTOR_TYPE.CUBE,
      },
      "connector_size": {
        "type": "number",
        "minimum": 0.1,
        "maximum": 0.8,
        "default": 0.5,
      },
      "connector_height": {
        "type": "number",
        "minimum": 0.1,
        "maximum": 0.8,
        "default": 0.1,
      },
      // Sent explicitly: the backend requests GLB and 3MF when the list is empty.
      "output_format": {
        "type": "array",
        "items": { "type": "string", "enum": Object.values(SPLIT_OUTPUT_FORMAT) },
        "default": [SPLIT_OUTPUT_FORMAT.GLB],
      },
    },
    "required": ["input_3d"],
    "allOf": [
      {
        "if": { "properties": { "split_mode": { "const": SPLIT_MODE.AUTO } } },
        "then": { "properties": { "prompt": false } },
      },
      {
        "if": { "properties": { "connectors": { "const": false } } },
        "then": {
          "properties": {
            "connector_type": false,
            "connector_size": false,
            "connector_height": false,
          },
        },
      },
    ],
    "additionalProperties": false,
  },
  "active_if": {},
}
